import makeStyles from '@mui/styles/makeStyles';
import { getBrandCustom } from "../../../utils/getCustomColor";

const styles = makeStyles(() => ({
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  keyboardDatepickerIcon: {
    width: "14px",
    height: "14px",
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
  label: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: (props: { disabled?: boolean }) =>
      props?.disabled ? "#667085" : getBrandCustom("primaryColor", "#308CDB"),
  },
  required: {
    color: (props: { disabled?: boolean }) => (props?.disabled ? "#667085" : "#F04438"),
  },
}));

export default styles;
